(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trade-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-trade-sticky]');
    var form = document.getElementById('trade-form');
    if (!bar || !form) return;

    var formVisible = false;
    var keyboardOpen = false;
    var formFocused = false;

    function sync() {
      var hide = formVisible || keyboardOpen || formFocused;
      bar.hidden = hide;
      document.documentElement.classList.toggle('pp-trade-sticky-active', !hide);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          formVisible = entry.isIntersecting;
          sync();
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      observer.observe(form);
    }

    form.addEventListener('focusin', function () {
      formFocused = true;
      sync();
    });
    form.addEventListener('focusout', function () {
      setTimeout(function () {
        formFocused = form.contains(document.activeElement);
        sync();
      }, 0);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        keyboardOpen = (window.innerHeight - window.visualViewport.height) > 120;
        sync();
      });
    }

    sync();
  })();

  (function () {
    var KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
    var KLAVIYO_REVISION = '2026-07-15';

    function splitName(full) {
      var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
      var name = {};
      if (parts.length) name.first_name = parts.shift();
      if (parts.length) name.last_name = parts.join(' ');
      return name;
    }

    // Klaviyo rejects any phone_number that is not E.164. Bare numbers are read as US/Canada.
    function toE164(raw) {
      var text = String(raw || '').trim();
      var digits = text.replace(/\D/g, '');
      if (text.charAt(0) === '+') return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null;
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits) ? '+1' + digits : null;
    }

    function fieldsFromForm(form) {
      var fields = {};
      new FormData(form).forEach(function (value, name) {
        var match = /^contact\[(.+)\]$/.exec(name);
        var text = String(value).trim();
        if (match && text) fields[match[1]] = text;
      });
      return fields;
    }

    function buildSubscription(fields, listId) {
      var profile = splitName(fields.name);
      var phone = toE164(fields.phone);
      var properties = {};
      Object.keys(fields).forEach(function (key) {
        if (key === 'email' || key === 'name' || key === 'subject') return;
        if (key === 'phone') {
          if (!phone) properties.Phone = fields.phone;
          return;
        }
        properties[key] = fields[key];
      });
      profile.email = fields.email;
      if (phone) profile.phone_number = phone;
      profile.properties = properties;
      // Email only: the form shows no SMS consent language.
      profile.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Trade page',
            profile: { data: { type: 'profile', attributes: profile } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
    }

    function subscribe(form) {
      return fetch(KLAVIYO_URL + encodeURIComponent(form.dataset.klaviyoKey), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(buildSubscription(fieldsFromForm(form), form.dataset.klaviyoList))
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
      });
    }

    function showSuccess(form) {
      var status = form.querySelector('[data-trade-success]');
      form.classList.add('is-submitted');
      if (!status) return;
      status.hidden = false;
      status.focus();
    }

    document.querySelectorAll('form[data-klaviyo-list]').forEach(function (form) {
      if (!form.dataset.klaviyoList || !form.dataset.klaviyoKey) return;
      var button = form.querySelector('[type="submit"]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (button) button.disabled = true;
        subscribe(form)
          .then(function () {
            showSuccess(form);
          })
          .catch(function () {
            // Keep the lead: fall back to the contact form, which emails the store.
            form.submit();
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
